import { MessageSquareTextIcon } from 'lucide-react'

import {
  useReportConfigOptions,
  useWizardSectionInstructions,
  useWizardSelectedSections,
} from '@/modules/analysis'
import type { ConfigSection } from '@/modules/projects'

// Read-only preview of the report the current selections produce. Editing
// happens in the sections column; this sidebar just reflects the result.
export const ReportPreview = () => {
  const config = useReportConfigOptions()
  const sectionInstructions = useWizardSectionInstructions()
  const wizardSelectedSections = useWizardSelectedSections()

  const sectionMap = new Map(
    config?.sections.map((section) => [section.key, section]),
  )
  const selectedSections = wizardSelectedSections
    .map((key) => sectionMap.get(key))
    .filter(Boolean) as ConfigSection[]

  return (
    <div className="space-y-3">
      <h3 className="text-[13px] font-medium text-ink-subtle">
        Report preview
      </h3>

      <div className="border-t">
        {selectedSections.map((section, index) => {
          const instruction = sectionInstructions[section.key]?.trim()
          return (
            <div key={section.key} className="border-b py-3 last:border-b-0">
              <div className="flex items-baseline gap-2">
                <span className="text-xs font-medium tabular-nums text-muted-foreground/50">
                  {index + 1}.
                </span>
                <div className="min-w-0 flex-1">
                  <p className="text-sm font-medium">{section.label}</p>
                  <p className="mt-0.5 text-xs text-muted-foreground/60">
                    {section.description}
                  </p>
                  {instruction && (
                    <div className="mt-1.5 space-y-1 border-l pl-3">
                      <div className="flex items-center gap-1.5">
                        <MessageSquareTextIcon className="h-3 w-3 shrink-0 text-blue-5" />
                        <span className="text-xs font-medium text-blue-5">
                          Your prompt
                        </span>
                      </div>
                      <p className="text-xs leading-relaxed text-blue-6">
                        {instruction}
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
